import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Credenciales de Scarjav SL (Cuenta de la Empresa - EL NUEVO)
const firebaseConfig = {
  apiKey: "AIzaSyAQ78RY4BzRPktgYLOD6VsSDp8kxjpXYG8",
  authDomain: "hoppytimeappscarjav.firebaseapp.com",
  projectId: "hoppytimeappscarjav",
  storageBucket: "hoppytimeappscarjav.firebasestorage.app",
  messagingSenderId: "400816125834",
  appId: "1:400816125834:web:02c60ab6157094c309ba73",
  measurementId: "G-81HDPWYLVE"
};

// Inicializamos Firebase con la nueva cuenta
const app = initializeApp(firebaseConfig);

// Exportamos los servicios para que toda la App los use
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

export default app;